const DEFAULT_PAGE_SIZE = 50;

export { DEFAULT_PAGE_SIZE };
